import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, NgZone, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { submitData } from '../booking/submitData';
import { InquiryService } from './inquiry.servvice';
import { sendData } from './inquiryData';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';


import { ToastrService } from 'ngx-toastr';
import { BookingService } from '../booking/booking.service';
import { DetailsService } from '../details.service';
import { ConfirmData } from '../booking/sendData';
import { SharedService } from '../../shared.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-inquiry',
  templateUrl: './inquiry.component.html',
  styleUrls: ['./inquiry.component.css']
})
export class InquiryComponent implements OnInit {
  noSpecifiedOffer: any;
  inquiryError: any;
  error: any;
  inquirySuccess: any;
  lowestPriceIndex: number;
  minPriceDouble: any;
  minPriceSingle: any;
  priceForSingle: string;
  priceForSingle1: string;
  priceForDouble: string;
  priceForDouble1: string;
  firstBoardType: string;

  // user type taken from shared service
  userType;
  premium: boolean; // if user is premium or not

  // number of times inquiry have been sent
  countSentInquiry = 0;

  // fields regarding trip details and their flags
  flightPrice: number = 0;
  boardPrice: number = 0;
  flightChanged: boolean = false;
  dateIdChanged: boolean = false;
  priceIdChanged: boolean = false;
  airportChanged: boolean = false;
  apiUrl = environment.apiBaseUrl;
  // TODO bogdan: replace this with tenant code from sessionData
  defaultTenant;
  productId: any;
  priceCalculated: boolean = false;
  boardTypeDefault: string;

  // send data for confirm modal
  confirmData: ConfirmData;

  //id of the offer from URL
  id: number;
  private sub: any;
  code: string;

  //data which will be displayed on error
  data: any;
  err: string;
  isErr: boolean;

  //data regarding information for trip
  longText:string;
  subText1:string;
  subText2:string;
  shortText:string;
  header:string;
  subHeader:string;
  imgSrc1;

  //two arrays of dates for single i double rooms
  SingleRoom;
  DoubleRoom;

  //fields for trip index
  flightFrom;
  boardUpgrades;
  room: number = 0;
  chosenDate: number = 0;
  dateID: number = 0;
  priceID: number = 0;
  roomPrice: number = 0;

  boardType: number = 99999;
  airport: number = 0;
  roomTypes;

  //string for price which is reloading with ng zone
  money: string = '0';
  money2: string = '0';

  numberOfParticipiants: number = 2;

  //fields for personal information
  salutations;
  countries;
  man;
  woman;
  salutationErr;

  // flag that allows user to select more trip details
  allowToSelect: boolean = true;

  //all data to be sent when form is submitted
  submitData: submitData;
  sendData: sendData;

  //salutations on currend language
  womanCode: string;
  manCode: string;

//url from details page which is sent
  backLink: string;

  // category for start component
  category;

  translations = {};

    constructor(private router: Router,
      private route: ActivatedRoute,
      private inquiryService: InquiryService,
      private detailsService: DetailsService,
      private bookingService: BookingService,
      private ref: ChangeDetectorRef,
      private zone: NgZone,
      private toastr: ToastrService,
      private sharedService: SharedService,
      private translate: TranslateService
      ) { }


    ngOnInit() {
      window.scrollTo(0, 0);
      let temp = localStorage.getItem('sessionData');
      let sessionData = JSON.parse(temp);
      this.defaultTenant = sessionData.tenantCode;
      sessionData.homepage.type === 'simpleTravel' ? this.premium = true : this.premium = false;
      this.backLink = sessionStorage.getItem('backLink')

      this.translate.getTranslation(this.translate.currentLang).subscribe(
        done => {
           this.inquirySuccess = done['inquiryPage'].success;
           this.inquiryError = done['inquiryPage'].error;
           this.error = done['commonTranslations'].error;
           this.noSpecifiedOffer = done['commonTranslations'].noSpecifiedOffer;
        });


      this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number
       // In a real app: dispatch action to load the details here.
    });

    this.sharedService.getUserType().subscribe(
      userType => this.userType = userType
    );
    //servise which get salutation for current session
    this.bookingService.getSalutations().subscribe(
      data =>{
        this.salutations = data.salutations
        this.man = data.salutations[0].name
        this.woman = data.salutations[1].name

        this.manCode = data.salutations[0].code
        this.womanCode = data.salutations[1].code
        this.submitData.salutationB = data.salutations[0].code
        this.submitData.salutation = data.salutations[0].code
        this.submitData.salutation1 = data.salutations[0].code
        // this.zone.run(() => this.man = data.salutations[0].name)
      } ,
      err => this.salutationErr = err,
      () => console.log('uspeh')
    )

    //calling service for array of countries
    this.bookingService.getCountries().subscribe(
      data =>{
        this.countries = data.countries
      },
      err => console.log(err),
      () => console.log('done')
    )

    //init of fields
    this.submitData = {
      date: '',
      roomType: '',
      airport: '',
      boardType: '',
      salutation: this.man,
      firstName: '',
      lastName: '',
      dateBirth: '',
        salutation1: this.man,
      firstName1: '',
      lastName1: '',
      dateBirth1: '',
      salutationB: '',
      firstNameB: '',
      lastNameB: '',
      street: '',
      streetNum: '',
      zip: '',
      city: '',
      country: 'DE',
      phone: '',
      email: '',
      checked: false
    }

    console.log(this.submitData.salutation);

      //init of data which will be sent do api
      this.sendData = {
        product: null,
        code: '',
        backLink: '',
        start: '',
        fromAirport: '',
        roomType: '',
        boardType: '',
        customer: {
          salutation: '',
          firstName: '',
          lastName: '',
          street: '',
          streetNumber: '',
          country: '',
          zip: '',
          city: '',
          phone: '',
          email: '',
        }
      }
    if (this.id) {
this.checkUserType().subscribe(
      data => {
        this.data = data;
        this.code = data.code;
        this.productId = data.id;
        this.longText = data.longText;
        this.boardTypeDefault = data.accommodation.boardType;
        this.sendData.product = this.productId;
        this.sendData.code = this.code;
        this.category = data.accommodation.category;
        this.header = data.header;
        this.subHeader = data.subHeader;
        this.subText1 = data.subText1;
        this.subText2 = data.subText2;
        this.shortText = data.shortText;
        if (this.data.files.length > 0) {
        this.imgSrc1 = this.apiUrl + 'dms/public/' + this.defaultTenant + '/' + this.data.files[0].id;
        }
        // else - mock images to be added
        this.firstBoardType = data.accommodation.boardTypeName;
        this.SingleRoom = this.data.accommodation.roomTypes[0].prices;
        this.DoubleRoom = this.data.accommodation.roomTypes[1].prices;
        this.roomTypes = this.data.accommodation.roomTypes;

        if (typeof this.SingleRoom !== 'undefined') {
          for(let s of this.SingleRoom) {
             let price = s.price
              s.pricee = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
            }
          }

          if (typeof this.DoubleRoom !== 'undefined') {
          for(let d of this.DoubleRoom) {
             let price = d.price
              d.pricee = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
            }
          }

        if(this.premium){
          this.flightFrom = this.data.flight.fromAirports;
          if (typeof this.flightFrom !== 'undefined') {
            for(let f of this.flightFrom){
              let price = f.price
              f.pricee = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
              }
            }
        }

        if(this.premium){
        this.boardUpgrades = this.data.accommodation.boardUpgrades;
        if (typeof this.boardUpgrades !== 'undefined') {
        for(let f of this.boardUpgrades){
          let price = f.price
          f.pricee = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
        }
        }
      }
      },
        err => {
        this.err = 'Unexpected error occured, status' + err.status, this.isErr = true;
        this.toastr.error(this.noSpecifiedOffer);
        this.router.navigate(['']);
       },
        () => console.log('complete')
         );
        }else {
        this.err = 'No specified offer',
        this.isErr = true;
        this.toastr.error(this.error)
        this.router.navigate(['']);
      }
  }// end of ngOnInit

    // function for back button
    back(){
      this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number
       // In a real app: dispatch action to load the details here.
      this.router.navigate(['/details', this.id]);
      });
    }

    totalPrice() {
      if (this.lowestPriceIndex === 1) {
        let totalprice = this.boardPrice + this.flightPrice + this.roomPrice;
        let price = totalprice;
        let pricefor2 = totalprice * 2;
        let priceForSingle = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price / 100);
        let priceForSingle1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price / 100);
        this.zone.run(() => this.priceForSingle = priceForSingle);
        this.zone.run(() => this.priceForSingle1 = priceForSingle1);
        this.ref.detectChanges();
      }else {
          // tslint:disable-next-line:max-line-length
          let totalprice = this.boardPrice + this.flightPrice + this.roomPrice;
          let price = totalprice;
          let pricefor2 = totalprice * 2;
          // tslint:disable-next-line:max-line-length
          let priceForDouble1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( pricefor2  / 100);
          this.zone.run(() => this.priceForDouble1 = priceForDouble1);
          let priceForDouble = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( price / 100);
          this.zone.run(() => this.priceForDouble = priceForDouble);
          this.lowestPriceIndex = 2;
          this.ref.detectChanges();
      }
        }

      //function for selecting airport
      selectAirport(id:number){
      let prc = this.flightFrom[id].price
      this.flightPrice = prc;
      this.airport = id;
      this.priceCalculated = true;
      this.airportChanged = true;
      }


      //select board type
      selectBoardType(id:number){
        this.flightChanged = true;
        if(id != 99999){
            let prc = this.boardUpgrades[id].price
            this.boardPrice = prc;
            this.priceCalculated = true;
            this.boardType = id;
        }else{
             this.boardPrice = 0;
          }
        }

      //check if room type is changed and if price is allowed to be displayed
      selectedDate1(){
        this.allowToSelect = false;
        this.priceIdChanged = true;
        this.priceCalculated = false;
        this.dateID = 0;
      }

      //id of date selected
      selectedDate(id){
        this.allowToSelect = false;
        this.dateID = id;
        this.priceCalculated = true;
        this.dateIdChanged = true;
      }

    priceIndex(id) {
      this.numberOfParticipiants = id + 1;

      if (id === 0) {
        if(this.SingleRoom !== undefined) {
        this.updateSinglePrices();
        if (this.dateID > this.SingleRoom.length - 1) {
          if (this.dateID !== undefined) {
            this.dateID = 0;
            this.roomPrice = this.SingleRoom[this.dateID].price;
            this.totalPrice();
          }else {
            this.roomPrice = this.minPriceSingle;
          }
        }else {
          if (this.dateID !== undefined){
          this.roomPrice = this.SingleRoom[this.dateID].price;
          this.totalPrice();
          }else {
            this.roomPrice = this.minPriceSingle;
          }
        }
    }
  }
    if (id === 1) {
      // tslint:disable-next-line:max-line-length
      if(this.DoubleRoom !== undefined){

     this.updateDoublePrices();
      if(this.dateID > this.DoubleRoom.length - 1){
        if(this.dateID !== undefined){
        this.dateID = 0;
        this.roomPrice = this.DoubleRoom[this.dateID].price;
        this.totalPrice()
        }else{
          this.roomPrice = this.minPriceDouble;
        }
      }else {
        if(this.dateID !== undefined){
        this.roomPrice = this.DoubleRoom[this.dateID].price;
        this.totalPrice()
        }else{
          this.roomPrice = this.minPriceDouble;
        }
      }
    }
      }
      this.priceID = id;
    }

    checkUserType() {
      if (this.userType === 'simpleTravel') {
          return this.detailsService.getOfferDetails(this.id);
        }else {
         return this.inquiryService.getPrdViewTravel(this.id);
      }
    }


    updateDoublePrices(){
      // tslint:disable-next-line:max-line-length
      let priceForDouble1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(( this.minPriceDouble * 2) / 100);
      this.zone.run(() => this.priceForDouble1 = priceForDouble1);
      let priceForDouble = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( this.minPriceDouble / 100);
      this.zone.run(() => this.priceForDouble = priceForDouble);
      this.lowestPriceIndex = 2;
      this.ref.detectChanges();
    }

    updateSinglePrices(){
      let priceForSingle1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( this.minPriceSingle / 100);
      this.zone.run(() => this.priceForSingle1 = priceForSingle1);
      let priceForSingle = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format( this.minPriceSingle / 100);
      this.zone.run(() => this.priceForSingle = priceForSingle);
      this.lowestPriceIndex = 1;
      this.ref.detectChanges();
    }

    // test for calculating min price
    calculateMinPrice(){
      this.minPriceSingle = this.SingleRoom[0].price;
      this.minPriceDouble = this.DoubleRoom[0].price;
      if (typeof this.DoubleRoom !== 'undefined') {
        for (let d of this.DoubleRoom) {
          if (d.price <  this.minPriceDouble) {
            this.minPriceDouble = d.price;
          }
        }
      }
      if (typeof this.SingleRoom !== 'undefined') {
        for (let s of this.SingleRoom) {
          if (s.price < this.minPriceSingle) {
            this.minPriceSingle = s.price;
          }
        }
      }
      if ( this.minPriceDouble <  this.minPriceSingle) {
        this.updateDoublePrices();
        this.roomPrice = this.minPriceDouble;

      }else {
        this.updateSinglePrices();
        this.roomPrice = this.minPriceSingle;
      }
    }

    //function which sends all data to api
    toggleSubmitAllData(){
      this.sendData.product = this.productId;
      this.sendData.code = this.code;
      this.sendData.backLink = this.backLink;
      this.sendData.customer.salutation = this.submitData.salutationB;
      this.sendData.customer.lastName = this.submitData.lastNameB;

      if(this.submitData.phone != ''){
      this.sendData.customer.phone = this.submitData.phone;
      }else{
        delete this.sendData.customer.phone;
      }

        if(this.submitData.email != ''){
      this.sendData.customer.email = this.submitData.email;
      }else{
        delete this.sendData.customer.email;
      }

        if(this.submitData.date != ''){
      this.sendData.start = this.submitData.date;
      }else{
        delete this.sendData.start;
      }

        if(this.submitData.firstNameB != ''){
      this.sendData.customer.firstName = this.submitData.firstNameB;
      }else{
        delete this.sendData.customer.firstName;
      }

        if(this.submitData.street != ''){
      this.sendData.customer.street = this.submitData.street;
      }else{
        delete this.sendData.customer.street;
      }

        if(this.submitData.streetNum != ''){
      this.sendData.customer.streetNumber = this.submitData.streetNum;
      }else{
        delete this.sendData.customer.streetNumber;
      }

        if(this.submitData.country != ''){
      this.sendData.customer.country = this.submitData.country;
      }else{
        delete this.sendData.customer.country;
      }

        if(this.submitData.zip != '' ){
      this.sendData.customer.zip = this.submitData.zip;
      }else{
        delete this.sendData.customer.zip;
      }
          if(this.submitData.city != ''){
      this.sendData.customer.city = this.submitData.city;
      }else{
        delete this.sendData.customer.city;
      }
      if (this.dateIdChanged === true) {
      this.sendData.start = this.SingleRoom[this.dateID].start;
      }else {
      this.sendData.start = '';
      }
      if (this.priceIdChanged == true){
      this.sendData.roomType = this.roomTypes[this.priceID].roomType;
      }else{
    this.sendData.roomType = '';
      }
      if(this.airportChanged == true){
      this.sendData.fromAirport = this.flightFrom[this.airport].airport;
      }else{
      this.sendData.fromAirport = '';
      }
      if(this.boardType == 99999){
        this.sendData.boardType = this.boardTypeDefault;
        console.log(this.boardTypeDefault);

      }else{

      this.sendData.boardType = this.boardUpgrades[this.boardType].boardType;
    }

      // if it is simpleTravel or basicTravel
      if (this.premium) {
        return this.inquiryService.sendDataToApi(this.sendData).subscribe(
          data => {
            this.confirmData = {} as ConfirmData;
            this.confirmData.flight =  {
              fromAirport: '',
              toAirport: ''
            },
            this.confirmData.type = data.bookingType;
            this.confirmData.customers = data.customerLines;
            this.confirmData.totalPriceString = data.totalPriceString;
            this.confirmData.travelPeriod = data.travelPeriod;
            this.confirmData.flight.toAirport = data.flight.toAirport;
            this.confirmData.flight.fromAirport = data.flight.fromAirport;
            this.confirmData.participants = new Array();
            document.getElementById('open-modal-booking').click();
            this.countSentInquiry++;
          },
          err => this.toastr.error(this.inquiryError),
        () => this.toastr.success( this.inquirySuccess)
        );
      }else {
        delete this.sendData.fromAirport;
        delete this.sendData.boardType;
        return this.inquiryService.sendInquiryData(this.sendData).subscribe(
          data => {
            this.confirmData = {} as ConfirmData;
            this.confirmData.flight =  {
              fromAirport: '',
              toAirport: ''
            },
            this.confirmData.type = data.bookingType;
            this.confirmData.customers = data.customerLines;
            this.confirmData.totalPriceString = data.totalPriceString;
            this.confirmData.travelPeriod = data.travelPeriod;
            this.confirmData.participants = new Array();
            document.getElementById('open-modal-booking').click();
            this.countSentInquiry++;
          },
          err => this.toastr.error(this.inquiryError),
        () => this.toastr.success(this.inquirySuccess)
        );
      }
    }// end of send api func
}



// WEBPACK FOOTER //
// ./src/app/details/inquiry/inquiry.component.ts